// ** MUI Imports
import Grid from '@mui/material/Grid'

// ** Views Imports
import HelpCard from 'src/components/help-center/HelpCard'

// ** Third Party Styles Imports
import 'react-datepicker/dist/react-datepicker.css'

const Settings = () => {
  return (
    <Grid>
        <HelpCard />
    </Grid>
  )
}

export default Settings
